module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow2-d9a7e1a52ee004146bb997835d19c39b.jpg";